import {Injectable} from '@angular/core';
import {AuthService, RestClientService} from 'shared-lib';
import {Observable} from 'rxjs';
import {UserOnboardingStatus} from './models/user-onboarding-status';

@Injectable({
  providedIn: 'root'
})
export class UserOnboardingStatusService {

  private userId: string | undefined;

  constructor(private restClient: RestClientService, private authService: AuthService) {
    this.authService.getCurrentUser$().subscribe(user => {
      if (user) {
        this.userId = user.id;
      }
    });
  }

  public getUserOnboardingStatus(): Observable<UserOnboardingStatus> {
    return this.restClient.get<UserOnboardingStatus>(`/onboarding/${this.userId}/status`);
  }

  public markUserOnboardingStatusAsDisplayed(): Observable<void> {
    return this.restClient.put<void>(`/onboarding/${this.userId}/status/loyalty`, {loyaltyOnboardingDisplayed: true});
  }
}
